import * as React from 'react'

import {
  ShiftManagementShiftConfigurationFragment,
  ShiftManagementTemplateWeekFragment,
} from 'generated/resources/graphql'
import groupBy from 'lodash/groupBy'

import { observer } from 'mobx-react'

import {
  isEmptyCell,
  isRestDay,
  isShift,
} from 'modules/shift_management/lib/getShiftConfigurationDayType'

import BlankCell from './BlankCell'
import EmptyCell from './EmptyCell'
import RestDayCell from './RestDayCell'
import ShiftCell from './ShiftCell'
import ShiftConfigRowBreaks from './ShiftConfigRowBreaks'

interface Props {
  day: number
  templateWeek: ShiftManagementTemplateWeekFragment
  shiftConfigs: ShiftManagementShiftConfigurationFragment[]
}

const TableCell = ({ day, templateWeek, shiftConfigs }: Props) => {
  const groupedByDay = groupBy(shiftConfigs, (shiftConfig) => shiftConfig.weekday)
  const weekday = day.toString()
  const shiftConfigsByDay = groupedByDay[weekday]

  if (!shiftConfigsByDay) return <BlankCell />

  return (
    <>
      {shiftConfigsByDay.map((shiftConfig) => (
        <>
          {isRestDay(shiftConfig) && <RestDayCell key={`restDayCell-${day}`} />}
          {isEmptyCell(shiftConfig) && <EmptyCell key={`emptyCell-${day}`} />}
          {isShift(shiftConfig) && (
            <>
              <ShiftCell
                templateWeek={templateWeek}
                shiftConfig={shiftConfig}
                key={shiftConfig.id}
              />
              <ShiftConfigRowBreaks plannedBreaks={shiftConfig.plannedBreaks} />
            </>
          )}
        </>
      ))}
    </>
  )
}

export default observer(TableCell)
